import React, { useEffect, useState } from "react";
import "./Header.css";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Logo from "../../assets/logo.png";
import HDSetting from "../../assets/hd_setting.svg";
import Bell from "../../assets/bell.svg";
import FacebookIconsHD from "../../assets/Facebook-link.svg";
import InstagramIconsHD from "../../assets/Instagram-link.svg";
import TwitterIconsHD from "../../assets/Twitter-link.svg";
import ParentalDecline from "../../assets/parental_decline.png";
import SearchIcon from "@mui/icons-material/Search";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MaleAvatar from "../../assets/MaleAvatar.png";
import FemaleAvatar from "../../assets/FemaleAvatar.png";
import ProfileVerifiedSmall from "../../assets/profile_verified_small.svg";
import ProfileUnverifiedSmall from "../../assets/profile_unverified_small.svg";
import Link from "@mui/material/Link";
import Fade from "@mui/material/Fade";
import CloseIcon from "@mui/icons-material/Close";
// import Alert from '@mui/material/Alert';
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import CardHeader from "@mui/material/CardHeader";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import Badge from "@mui/material/Badge";
import Storage from "@aws-amplify/storage";
import { smartTechEventLog } from "./../auth/util/util";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { API, Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../actions/profileActions";

// Search Bar Code START here

import PropTypes from "prop-types";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import Skeleton from "@mui/material/Skeleton";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useCookies } from "react-cookie";
import ConfirmationPopup from "./ConfirmationPopup";
import { appLink, baseURL, CONFIGURATOR_URL } from "../auth/util/CustomConstants";
import { addEventLog, getUseraccess } from "./../auth/util/util";
import { notificationsAction } from "../actions/notificationsAction";
import NotificationList from "./Notifications/NotificationList";
import AdminLogo from "./Settings/AdminLogo";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";
import * as queries from "../../graphql/queries";
import { getSignedUrl } from "../auth/util/util";
import { userActions } from "../actions/userActions";
import { getAccessToken } from "../../services/helpers";
const drawerBleeding = 0;

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor:
    theme.palette.mode === "light"
      ? grey[100]
      : theme.palette.background.default,
}));

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "light" ? "#fff" : grey[800],
}));

const Puller = styled(Box)(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === "light" ? grey[300] : grey[900],
  borderRadius: 3,
  position: "absolute",
  top: 0,
  left: "calc(50% - 15px)",
}));

// Search Bar Code END here

const pages = [
  "Career Paths",
  "Counselling",
  "Courses",
  "News",
  "Fun",
  "Talk Show",
];
const settings = [
  "Profile",
  "My Report",
  "My Purchases",
  "My Connections",
  "Portfolio",
  "CV Builder",
  "Logout",
];
if (localStorage.getItem("isAdmin") == "1") {
  settings.splice(1, 0, "Institute Dashboard", "Quiz Dashboard");
}
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const useScrollHandler = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollCheck = window.scrollY > 150;
      setScroll(scrollCheck);
    };

    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [scroll, setScroll]);

  return scroll;
};

function Header(props) {
  const scroll = useScrollHandler();
  const dispatch = useDispatch();
  const profileReducer = useSelector((state) => state.profileReducer);
  const notificationList = useSelector(
    (state) => state.notificationState.notifications
  );
  // Search Bar Code END here
  const { window } = props;
  const [openSearchBar, setOpenSearchBar] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpenSearchBar(newOpen);
  };

  // This is used only for the example
  const container =
    window !== undefined ? () => window().document.body : undefined;

  // Search Bar Code END here

  const [openCanLogin, setOpenCanLogin] = React.useState(false);
  const handleClickOpenCanLogin = () => {
    setOpenCanLogin(true);
  };
  const handleCloseCanLogin = () => {
    setOpenCanLogin(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [profileImage, setProfileImage] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies([
    "access_token",
    "userDetails",
  ]);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElNavNotification, setAnchorElNavNotification] =
    React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [isFeedPage, setIsFeedPage] = React.useState(false);
  const [isProfilePage, setIsProfilePage] = React.useState(false);
  const [notificationBell, setNotificationBell] = React.useState(false);

  let navigate = useNavigate();
  const location = useLocation();
  const currentPage = location.pathname;
  const [userAccess, setUserAccess] = useState({});
  const authenticationState = useSelector((state) => state.authenticationState);
  useEffect(() => {
    const initiateFun = async () => {
      let userID = localStorage.getItem("userID");

      if (!userID) {
        if (
          location.pathname.slice(0, location.pathname.lastIndexOf("/")) !=
            "/profile" &&
          location.pathname.slice(
            0,
            location.pathname.lastIndexOf("project")
          ) != "/" &&
          location.pathname.slice(0, location.pathname.lastIndexOf("cv")) !=
            "/" &&
          location.pathname.slice(0, location.pathname.lastIndexOf("blog")) !=
            "/" &&
          location.pathname.slice(0, location.pathname.lastIndexOf("posts")) !=
            "/" &&
          location.pathname.slice(0, location.pathname.lastIndexOf("my-courses")) !=
          "/" 
          &&
          location.pathname.slice(0, location.pathname.lastIndexOf("competitions")) !=
          "/"
          &&
          location.pathname.slice(0, location.pathname.lastIndexOf("product-catalogs-list")) !=
          "/"
          && 
          !location.pathname.slice(0, location.pathname.includes("revision-practice-buddy/demo/")) 
        ) {
          const currentPageWithoutSlash = currentPage?.replace("/", "");
          const redirectUrl = `/signin?redirect=${currentPageWithoutSlash}`;
          localStorage.setItem("currentPage", currentPageWithoutSlash);
          navigate(process.env.PUBLIC_URL + redirectUrl);
        }
      } else {
        let loginExpireTime = new Date(localStorage.getItem("loginExpireTime"));
        if (loginExpireTime) {
          let dateNow = new Date(Date.now());
          if (dateNow.getTime() > loginExpireTime.getTime()) {
            navigate(process.env.PUBLIC_URL + "/logout");
          }
        }
      }
      setFirstName(localStorage.getItem("firstName"));
      setLastName(localStorage.getItem("lastName"));
      setUsername(localStorage.getItem("username"));
      let profilePics = localStorage.getItem("profile_image");
      let uploadedImage = localStorage.getItem("uploaded_image");
      if (profilePics != null && uploadedImage === "true") {
        await getSignedUrl(localStorage.getItem("profile_image"), {
          level: "public",
        })
          .then(setProfileImage)
          .catch((err) => console.log(err));
      } else {
        setProfileImage(profilePics);
      }

      if (currentPage == "/my-feed/" || currentPage == "/my-feed") {
        setIsFeedPage(true);
      }
      if (
        location.pathname.slice(0, location.pathname.lastIndexOf("/")) ==
        "/profile"
      ) {
        setIsProfilePage(true);
      }
      if (localStorage.getItem("userID")) {
        var profileuserrolenewData = "";
        profileuserrolenewData = getUseraccess(localStorage.getItem("userID"));
        profileuserrolenewData.then(async (profiledata) => {
          setUserAccess(profiledata);
        });

        await dispatch(notificationsAction.allNotifications());
      }
    };
    // check for user session only if the user is logged in
    if(localStorage.getItem("userDetailsID")) {
      checkSession();
    }
    initiateFun();
  }, []);

  // side effect to update the userAccessRole, which updates the verified badge on the profile picture
  useEffect(()=>{
    try{
      if(authenticationState && authenticationState?.isMobileVerified && localStorage.getItem("userID")){
        // console.log("Need to update the userAccessRole");
        let profileuserrolenewData = getUseraccess(
          localStorage.getItem("userID")
        );
        profileuserrolenewData.then(async (profiledata) => {
          setUserAccess(profiledata);
          // console.log("update the userAccessRole", profiledata);
        });
      }
    }catch(error){
      console.error("Error in useEffect", error);
    }
  },[authenticationState])

  useEffect(() => {
    const initiateFunT = async () => {
      if (notificationList.length > 0) {
        let readNotifications = notificationList.find(
          (items) => items.read === 0
        );
        if (readNotifications) {
          setNotificationBell(true);
        } else {
          setNotificationBell(false);
        }
      }
    };
    initiateFunT();
  }, [notificationList]);

  const expiredOrInvalidSessionAction = async (keyPrefix,email) => {
    try {
      // console.log("Session is Expired/Invalid")
      // console.log("KeyPrefix", keyPrefix)
      // console.log("email", email)
      // console.log("loginExpireTime in local storage", localStorage.getItem('loginExpireTime'))
      // console.log("Device key in localstorage", localStorage.getItem(`${keyPrefix}.${email}.deviceKey`))
      localStorage.removeItem('loginExpireTime')
      localStorage.removeItem(`${keyPrefix}.${email}.deviceKey`)
      dispatch(userActions.logout());
      navigate(process.env.PUBLIC_URL + "/signin");
      return;
    } catch(error) {
      console.error("Something went wrong in expiredOrInvalidSessionAction", error)
    }
  }

  const checkSession = async () => {
    try {
      const googleAuth = JSON.parse(localStorage.getItem("googleAuth"))
      if(googleAuth && 'token' in googleAuth && 'email' in googleAuth) {
        // device tracking for Google Authenticated user not available
        // Using Refresh Logic to check the Google Session validity, if the session is expired or invalid then the refresh token will be revoked and the user will be logged out
        // This flow also works if the user has reset the Google Account password and comes back to MySphere
        await getAccessToken();
        return;
      } else {
        const currentCogntioUser = await Auth.currentAuthenticatedUser();
        if(currentCogntioUser && currentCogntioUser.signInUserSession) {
          const accessToken = currentCogntioUser.signInUserSession.accessToken.jwtToken
          const deviceKey = currentCogntioUser.signInUserSession.accessToken.payload.device_key
          const keyPrefix = currentCogntioUser.keyPrefix 
          const userDevicesResponse = await API.post("welcomeemaildev","/userdevices", {
            body: {
              accessToken: accessToken,
              isPasswordChange: false
            }
          })
          // console.log("userDevicesResponse", userDevicesResponse)
    
          if(userDevicesResponse.devices.length > 0) {
            // check if session is valid, if valid then do nothing, if invalid then remove device key and login expire time from local storage and redirect to login page
    
            let isValidDevice = userDevicesResponse.devices.find(item => item.DeviceKey === deviceKey)
            // console.log("isValidDevice", isValidDevice)
            if(!isValidDevice) {
              if(location.pathname !== "/my-courses") {
                await expiredOrInvalidSessionAction(keyPrefix, localStorage.getItem('email'))
              }
            }
          } else {
            // session is invalid if no devices exist for user, this means password was changed very recently
            if(location.pathname !== "/my-courses") {
              await expiredOrInvalidSessionAction(keyPrefix, localStorage.getItem('email'))
            } 
          }
        }
      }

    } catch(error) {
      console.error("Error checking current session", error);
    }
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleOpenNavMenuNotification = async (event) => {
    smartTechEventLog(localStorage.getItem("email"), "Click Notification Icon");
    setAnchorElNavNotification(event.currentTarget);
    if (notificationList.length > 0) {
      let readNotifications = notificationList.find(
        (items) => items.read === 0
      );

      if (readNotifications) {
        await dispatch(
          notificationsAction.updateNotificationsItems(notificationList)
        );
      }
    }
  };
  const handleCloseNavMenuNotification = async () => {
    setAnchorElNavNotification(null);
    await dispatch(notificationsAction.allNotifications());
  };

  const handleOpenUserMenu = (event) => {
    var index = settings.indexOf("Institute Dashboard");
    if (index !== -1) {
      settings.splice(index, 2);
    }
    if (localStorage.getItem("isAdmin") == "1") {
      settings.splice(1, 0, "Institute Dashboard", "Quiz Dashboard",);
    }

    if(localStorage.getItem("isAdmin") == "1" && !settings.includes("Project Dashboard")) {
      settings.splice(1, 0, "Project Dashboard");
    }

    if (
      localStorage.getItem("isGroupSchoolAdmin") === "1" &&
      localStorage.getItem("isSchoolAdmin") !== "1" &&
      !localStorage.getItem("orgRole") 
    ) {
      if (!settings.includes("Group School Dashboard")) {
        settings.splice(1, 0, "Group School Dashboard");
      }
    }
    if (
      localStorage.getItem("isGroupSchoolAdmin") === "1" &&
      localStorage.getItem("isSchoolAdmin") === "1" &&
      !localStorage.getItem("orgRole") 
    ) {
      // if(!settings.includes("Group School Dashboard") && !settings.includes("School Dashboard")) {
      //     settings.splice(1, 0,'Group School Dashboard','School Dashboard');
      // }
      if (!settings.includes("Group School Dashboard")) {
        settings.splice(1, 0, "Group School Dashboard");
      }
    }

    if (
      localStorage.getItem("isGroupSchoolAdmin") !== "1" &&
      localStorage.getItem("isSchoolAdmin") === "1" &&
      !localStorage.getItem("orgRole") 
    ) {
      if (!settings.includes("School Dashboard")) {
        settings.splice(1, 0, "School Dashboard");
      }
    }

    if(localStorage.getItem("isTeacher") === "1"){
      settings.splice(1,0,"Teacher Dashboard")
    }

    if(localStorage.getItem("orgRole") === "CHILD_ORGANIZATION_ADMIN"){
      if(!settings.includes("Organization Dashboard")) {
        settings.splice(1, 0, "Organization Dashboard");
      }
    }

    if(localStorage.getItem("orgRole") === "INSTRUCTOR"){
      if(!settings.includes("Cohort Dashboard")) {
        settings.splice(1, 0, "Cohort Dashboard");
      }
    }

    if(localStorage.getItem("orgRole") === "GROUP_ORGANIZATION_ADMIN"){
      if(!settings.includes("Group Organization Dashboard")) {
        settings.splice(1, 0, "Group Organization Dashboard");
      }
    }

    if(localStorage.getItem("orgRole") === "PUBLISHER"){
      if(!settings.includes("Publish Books")) {
        settings.splice(1, 0, "Publish Books");
      }
    }

    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const menuClick = async (page) => {
    if (page == "Logout") {
      if(settings.includes("Group School Dashboard")) {
        let index = settings.indexOf("Group School Dashboard")
        if(index !== -1) {
          settings.splice(index, 1)
        }  
      }
      if(settings.includes("School Dashboard")) {
        let index = settings.indexOf("School Dashboard")
        if(index !== -1) {
          settings.splice(index, 1)
        }  
      }
      if(settings.includes("Teacher Dashboard")) {
        let index = settings.indexOf("Teacher Dashboard")
        if(index !== -1) {
          settings.splice(index, 1)
        }  
      }
      navigate(process.env.PUBLIC_URL + "/logout");
    }
    if (page == "Profile") {
      navigate(process.env.PUBLIC_URL + "/profile/" + username);
      if (location.pathname !== "/profile/" + username) {
        if (
          location.pathname.slice(0, location.pathname.lastIndexOf("/")) ==
          "/profile"
        ) {
          navigate(0);
        }
      }
    }
    if (page == "My Connections") {
      navigate(process.env.PUBLIC_URL + "/my-connections/connection-requests");
    }
    if (page == "My Report") {
      navigate(process.env.PUBLIC_URL + "/revision-practice-buddy/report");
    }
    if (page == "My Purchases") {
      navigate(process.env.PUBLIC_URL + "/my-purchases");
    }
    if (page == "CV Builder") {
      navigate(process.env.PUBLIC_URL + "/create-cv");
    }
    if (page == "Portfolio") {
      navigate(process.env.PUBLIC_URL + "/portfolio");
    }
    if (page == "Sign in") {
      navigate(process.env.PUBLIC_URL + "/signin");
    }
    if (page == "Settings") {
      navigate(process.env.PUBLIC_URL + "/settings/account-information");
    }
    if (page == "Institute Dashboard") {
      //navigate(process.env.PUBLIC_URL+"/admin1003/my-students");
      global.window.open(process.env.PUBLIC_URL + "/my-students", "_blank");
    }
    if (page == "Quiz Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/quiz-results", "_blank");
    }
    if (page == "Project Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/project-dashboard", "_blank");
    }
    if (page === "Group School Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/group-admin", "_blank");
    }
    if (page === "School Dashboard") {
      //user is a school admin only so on clicking this take the user directly to school details page
      const schoolDetails = await fetchSearchItemsNextToken({
        query: queries.searchChildSchools,
        variables: {
          limit: 100,
          filter: { school_admin_email: { eq: localStorage.getItem("email") } },
        },
      });
      if (schoolDetails.length > 0) {
        global.window.open(
          process.env.PUBLIC_URL + `/school-admin/${schoolDetails[0].id}`,
          "_blank"
        );
      } else {
        navigate(process.env.PUBLIC_URL + "/my-feed");
      }
    }
    if (page === "Teacher Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/teacher/assessment", "_blank");
    }
    if (page === "Organization Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/organization-dashboard", "_blank");
    }
    if (page === "Cohort Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/cohort-dashboard", "_blank");
    }
    if (page === "Group Organization Dashboard") {
      global.window.open(process.env.PUBLIC_URL + "/group-organization-dashboard");
    }
    if (page === "Publish Books") {
      global.window.open(process.env.PUBLIC_URL + "/publisher/books");
    }
  };
  const [openTost, setOpenTost] = React.useState(false);
  const handleClickTost = () => {
    setOpenTost(true);
  };

  const handleCloseTost = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenTost(false);
  };

  const keyPressed = (e) => {
    if (e.keyCode == 13) {
      //navigate('https://www.mysphere.net/?s='+e.target.value)

      // global.window.open("https://www.mysphere.net/?s="+e.target.value, '_blank');
      global.window.open(appLink + "?s=" + e.target.value, "_self");
    }
  };
  const logEvent = (title, redlink) => {
    smartTechEventLog(localStorage.getItem("email"), title);
    global.window.open(redlink, "_self");
  };

  const [aiMenuAnchorEl, setAiMenuAnchorEl] = useState(null);
  const aiMenuOpen = Boolean(aiMenuAnchorEl);
  const [productsMenuAnchorEl, setProductsMenuAnchorEl] = useState(null);
  const productsMenuOpen = Boolean(productsMenuAnchorEl);
  const handleAiMenuOpen = (event) => {
    setAiMenuAnchorEl(event.currentTarget);
  }
  const handleAiMenuClose = () => {
    setAiMenuAnchorEl(null);
  }

  const handleProductsMenuOpen = (event) => {
    setProductsMenuAnchorEl(event.currentTarget);
  }
  const handleProductsMenuClose = () => {
    setProductsMenuAnchorEl(null);
  }

  const handleCuriosityGymProductsClick = () => {
    console.log("Opening Curiosity Gym Configurator Kits page");
    global.window.open(CONFIGURATOR_URL + "/kits", "_blank");
  }

  return (
    <>
      <Grid className="mainAppHeader">
        <Grid container className="hd_search_socail">
          <Grid item xs={7} md={6}>
            <Grid className="hd_searchbar">
              <Input
                onKeyDown={(e) => keyPressed(e)}
                endAdornment={
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={5} md={6} className="hd_social">
            {/* <Grid className='hd_searchbar_icon'>
                        <SearchIcon onClick={toggleDrawer(true)}/>
                    </Grid> */}
            <Grid className="hd_top_socail_notification">
              <ul className="hd_socails">
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/myspherenet"
                  >
                    <img src={FacebookIconsHD} />
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://instagram.com/myspherenet">
                    <img src={InstagramIconsHD} />
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com/myspherenet">
                    <img src={TwitterIconsHD} />
                  </a>
                </li>
                <li className="settingOptionLink">
                  <a
                    href={`${process.env.PUBLIC_URL}/settings/account-information`}
                  >
                    <img src={HDSetting} />
                  </a>
                </li>
              </ul>
              <div className="notificationReceivedWrap">
                <IconButton
                  size="small"
                  aria-label="account of current user"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenuNotification}
                  color="inherit"
                >
                  <img src={Bell} />
                  {notificationBell === true && (
                    <span className="notificationReceived"></span>
                  )}
                </IconButton>
                <Menu
                  className="notificationListMain"
                  id="menu-appbar"
                  anchorEl={anchorElNavNotification}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElNavNotification)}
                  onClose={handleCloseNavMenuNotification}
                >
                  <NotificationList
                    closeNotification={() => handleCloseNavMenuNotification()}
                  />
                </Menu>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <AppBar
          position="sticky"
          style={{ position: scroll ? "fixed" : "relative" }}
        >
          <Container className="hdContainer">
            <Toolbar disableGutters>
              <Grid className="mysphere_logo" sx={{ mr: 2, display: { xs: "none", md: "flex" } }}>
                <Link href={appLink + "my-feed"} className="AppMainLogo">
                  <img src={Logo} alt='MySphere'/>
                  {/* <AdminLogo /> */}
                </Link>
              </Grid>
              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <IconButton
                  className="hb_menu"
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                {/* <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                            >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={()=>menuClick(page)}>
                                <Typography textAlign="center">{page}</Typography>
                                </MenuItem>
                            ))}
                            </Menu> */}
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  <ul className="hd_navigations_mobile">
                    <li className="hdNavButtons">
                      <Link
                        className={isFeedPage == true ? "active" : ""}
                        href={`${process.env.PUBLIC_URL}/my-feed`}
                      >
                        My Feed
                      </Link>
                    </li>
                    <li className="hdNavButtons">
                      <div>
                        <Button
                          aria-controls={aiMenuOpen ? 'basic-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={aiMenuOpen ? 'true' : undefined}
                          onClick={handleAiMenuOpen}
                          style={{
                            color: "#ffffff",
                            margin: "8px 0",
                            padding: "0", 
                            borderRadius: "4px",
                            position: "relative",
                          }}
                        >
                          <span style={{ position: "absolute", top: "0", right: "0", color: "purple", fontSize: "8px", transform: "translate(50%, -70%)" }}>new</span>
                          <span style={{
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#000",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}>Self Learning</span>
                        </Button>
                        <Menu
                          id="basic-menu"
                          anchorEl={aiMenuAnchorEl}
                          open={aiMenuOpen}
                          onClose={handleAiMenuClose}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          {localStorage.getItem("orgRole") !== null && localStorage.getItem("orgRole") !== "null" && (
                            <MenuItem 
                              onClick={()=>{
                                console.log("Clicked on AI Assessment Maker")
                                handleAiMenuClose()
                                logEvent(
                                  "Clicked on AI Subject revision and practice buddy",
                                  baseURL + "/subject-revision-practice-buddy/"
                                )
                                }}
                            >
                                Subject Revision & Practice Buddy
                            </MenuItem>
                          )}
                          <MenuItem 
                            onClick={()=>{
                              handleAiMenuClose()
                              logEvent(
                                "Clicked on Revision and Practice Buddy",
                                baseURL + "/revision-practice-buddy/"
                              )
                              }}
                          >
                              Revision & Practice Buddy
                          </MenuItem>
                          <MenuItem 
                            onClick={()=>{
                              handleAiMenuClose()
                              logEvent(
                                "Clicked on AI Skill Development",
                                baseURL + "/ai-skill-journey/"
                              )
                              }}
                          >
                              Skill Development
                          </MenuItem>
                          {/* <MenuItem 
                            onClick={()=>{
                              handleAiMenuClose()
                              logEvent(
                                "Clicked on AI-DEMO",
                                baseURL + "/ai-demo-v4/"
                              )
                              }}
                          >
                              MCQs For Courses
                          </MenuItem> */}
                          <MenuItem 
                            onClick={()=>{
                              console.log("Clicked on AI Assessment Maker")
                              handleAiMenuClose()
                              logEvent(
                                "Clicked on AI Assessment Maker",
                                baseURL + "/ai-assessment-dashboard/"
                              )
                              }}
                          >
                              Upload Book 
                          </MenuItem>
                        </Menu>
                      </div>
                    </li>
                    <li className="hdNavButtons">
                      <div>
                        <Button
                          aria-controls={productsMenuOpen ? 'products-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={productsMenuOpen ? 'true' : undefined}
                          onClick={handleProductsMenuOpen}
                          style={{
                            color: "#ffffff",
                            margin: "8px 0",
                            padding: "0",
                            borderRadius: "4px",
                            position: "relative",
                          }}
                        >
                           <span style={{ position: "absolute", top: "0", right: "0", color: "purple", fontSize: "8px", transform: "translate(50%, -70%)" }}>new</span>
                          <span style={{
                            fontSize: "14px",
                            lineHeight: "21px",
                            color: "#000",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}>Products</span>
                        </Button>
                        <Menu
                          id="products-menu"
                          anchorEl={productsMenuAnchorEl}
                          open={productsMenuOpen}
                          onClose={handleProductsMenuClose}
                          MenuListProps={{
                            'aria-labelledby': 'products-button',
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              handleProductsMenuClose()
                              logEvent(
                                "Clicked on DIY STEM",
                                process.env.PUBLIC_URL + "/product-catalogs"
                              )
                            }}
                          >
                            DIY STEM
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleCuriosityGymProductsClick()
                              logEvent(
                                "Clicked on Electronics and Robotics Kits",
                                process.env.PUBLIC_URL + "/my-feed"
                              )
                            }}
                          >
                            Electronics and Robotics Kits
                          </MenuItem>
                        </Menu>
                      </div>
                    </li>
                    <li className="hdNavButtons">
                      <Link href={appLink + "career-paths/"}>Career Paths</Link>
                    </li>
                    {/* <li className="hdNavButtons">
                      <Link href={appLink + "counselling/"}>Counselling</Link>
                    </li> */}
                    {/* <li className="hdNavButtons">
                      <Link href={appLink + "competitions/"}>Competitions</Link>
                    </li> */}
                    <li className="hdNavButtons">
                      <Link href={appLink + "courses/"}>Courses</Link>
                    </li>
                    {/* <li className="hdNavButtons">
                      <Link href={appLink + "competitions/"}>
                        Competitions
                      </Link>
                    </li> */}
                    {/* <li className='hdNavButtons'><Link href={appLink+"news-and-articles/"}>News</Link></li>
                                    <li className='hdNavButtons'><Link className="" aria-controls={open ? 'fade-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>Fun <ExpandMoreIcon /></Link></li> */}
                    {/* <li className="hdNavButtons">
                      <Link href={appLink + "spheres-of-learning-talk-show/"}>
                        Talk Show
                      </Link>
                    </li> */}
                  </ul>
                  {!localStorage.getItem("userID") && (
                    <Link
                      href={`${process.env.PUBLIC_URL}/signin`}
                      className="login-mobile desk-hide"
                    >
                      Sign in
                    </Link>
                  )}
                </Menu>
              </Box>
              <Grid
                sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
                className="mob_logo_center"
              >
                <Link href={appLink + "my-feed"} className="AppMainLogo">
                  {/* <img src={Logo} alt='MySphere'/> */}
                  <AdminLogo />
                </Link>
              </Grid>
              <ul className="hd_navigations">
                <li className="hdNavButtons">
                  <Link
                    className={isFeedPage == true ? "active" : ""}
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent(
                        "Clicked on My Feed",
                        process.env.PUBLIC_URL + "/my-feed"
                      )
                    }
                  >
                    My Feed
                  </Link>
                </li>
                <li className="hdNavButtons">
                  <div>
                    <Button
                      aria-controls={aiMenuOpen ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={aiMenuOpen ? 'true' : undefined}
                      onClick={handleAiMenuOpen}
                      style={{
                        color: "#ffffff",
                        margin: "8px 0",
                        padding: "0",
                        position: "relative",
                        borderRadius: "4px",
                      }}
                    >
                      <span style={{ position: "absolute", top: "0", right: "0", color: "purple", fontSize: "9px", transform: "translate(50%, -50%)" }}>new</span>
                      <span style={{
                        padding: "4px 8px",
                        fontSize: "14px",
                        lineHeight: "21px",
                        color: "#000",
                        fontWeight: "500",
                        textTransform: "capitalize",
                      }}>Self Learning</span>
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={aiMenuAnchorEl}
                      open={aiMenuOpen}
                      onClose={handleAiMenuClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      {/* <MenuItem 
                        onClick={()=>{
                          handleAiMenuClose()
                          logEvent(
                            "Clicked on AI-DEMO",
                            baseURL + "/ai-demo/"
                          )
                          }}
                      >
                          Descriptive Q&A
                      </MenuItem> */}
                      {localStorage.getItem("orgRole") !== null && localStorage.getItem("orgRole") !== "null" && (
                        <MenuItem 
                              onClick={()=>{
                                handleAiMenuClose()
                                logEvent(
                                  "Clicked on Subject revision and practice buddy",
                                  baseURL + "/subject-revision-practice-buddy/"
                                )
                                }}
                            >
                              Subject Revision & Practice Buddy
                          </MenuItem>
                      )}
                      <MenuItem 
                            onClick={()=>{
                              handleAiMenuClose()
                              logEvent(
                                "Clicked on Revision and Practice Buddy",
                                baseURL + "/revision-practice-buddy/"
                              )
                              }}
                          >
                              Revision & Practice Buddy
                          </MenuItem>
                      <MenuItem 
                        onClick={()=>{
                          handleAiMenuClose()
                          logEvent(
                            "Clicked on AI Skill Development",
                            baseURL + "/ai-skill-journey/"
                          )
                          }}
                      >
                          Skill Development
                      </MenuItem>
                      {/* <MenuItem 
                        onClick={()=>{
                          handleAiMenuClose()
                          logEvent(
                            "Clicked on AI-DEMO",
                            baseURL + "/ai-demo-v4/"
                          )
                          }}
                      >
                          MCQs For Courses
                      </MenuItem> */}
                      <MenuItem 
                        onClick={()=>{
                          console.log("Clicked on AI Assessment Maker")
                          handleAiMenuClose()
                          logEvent(
                            "Clicked on AI Assessment Maker",
                            baseURL + "/ai-assessment-dashboard/"
                          )
                          }}
                      >
                          Upload Book 
                      </MenuItem>
                    </Menu>
                  </div>
                </li>
                <li className="hdNavButtons">
                  <div>
                    <Button
                      aria-controls={productsMenuOpen ? 'products-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={productsMenuOpen ? 'true' : undefined}
                      onClick={handleProductsMenuOpen}
                      style={{
                        color: "#ffffff",
                        margin: "8px 0",
                        padding: "0",
                        position: "relative",
                        borderRadius: "4px",
                      }}
                    >
                      <span style={{ position: "absolute", top: "0", right: "0", color: "purple", fontSize: "8px", transform: "translate(50%, -70%)" }}>new</span>
                      <span style={{
                        padding: "4px 8px",
                        fontSize: "14px",
                        lineHeight: "21px",
                        color: "#000",
                        fontWeight: "500",
                        textTransform: "capitalize",
                      }}>Products</span>
                    </Button>
                    <Menu
                      id="products-menu"
                      anchorEl={productsMenuAnchorEl}
                      open={productsMenuOpen}
                      onClose={handleProductsMenuClose}
                      MenuListProps={{
                        'aria-labelledby': 'products-button',
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleProductsMenuClose()
                          logEvent(
                            "Clicked on DIY STEM",
                            process.env.PUBLIC_URL + "/product-catalogs"
                          )
                        }}
                      >
                        DIY STEM
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleCuriosityGymProductsClick()
                          logEvent(
                            "Clicked on Electronics and Robotics Kits",
                            process.env.PUBLIC_URL + "/my-feed"
                          )
                        }}
                      >
                        Electronics and Robotics Kits
                      </MenuItem>
                    </Menu>
                  </div>
                </li>
                <li className="hdNavButtons">
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent(
                        "Clicked on Career Paths",
                        appLink + "career-paths/"
                      )
                    }
                  >
                    Career Paths
                  </Link>
                </li>
                {/* <li className="hdNavButtons">
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent(
                        "Clicked on Counselling",
                        appLink + "counselling/"
                      )
                    }
                  >
                    Counselling
                  </Link>
                </li> */}
                {/* <li className="hdNavButtons">
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent(
                        "Clicked on Competitions",
                        appLink + "competitions/"
                      )
                    }
                  >
                    Competitions
                  </Link>
                </li> */}
                <li className="hdNavButtons">
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent("Clicked on Courses", appLink + "my-courses/")
                    }
                  >
                    Courses
                  </Link>
                </li>
                {/* <li className="hdNavButtons">
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent(
                        "Clicked on Courses",
                        appLink + "competitions/"
                      )
                    }
                  >
                    Competitions
                  </Link>
                </li> */}
                {/* <li className='hdNavButtons'><Link href="javascript:void(0)" onClick={()=>logEvent("Clicked on News",appLink+"news-and-articles/")}>News</Link></li>
                                <li className='hdNavButtons'><Link className="hd_menus" aria-controls={open ? 'fade-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick}>Fun <ExpandMoreIcon /></Link></li> */}
                {/* <li className="hdNavButtons">
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent(
                        "Clicked on Talk Show",
                        appLink + "spheres-of-learning-talk-show/"
                      )
                    }
                  >
                    Talk Show
                  </Link>
                </li> */}
              </ul>
              <Menu
                className="mainNavMenu"
                id="fade-menu"
                MenuListProps={{
                  "aria-labelledby": "fade-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
              >
                <MenuItem>
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent("Clicked on Quizzes", appLink + "quiz/")
                    }
                  >
                    Quizzes
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link
                    href="javascript:void(0)"
                    onClick={() =>
                      logEvent("Clicked on Trivia", appLink + "trivia/")
                    }
                  >
                    Trivia
                  </Link>
                </MenuItem>
              </Menu>
              <Box sx={{ flexGrow: 0 }} className="mobileView_search">
                {localStorage.getItem("userID") && (
                  <>
                    <Tooltip title={firstName + " " + lastName}>
                      <Button
                        onClick={handleOpenUserMenu}
                        sx={{ p: 0 }}
                        className="profileNameButton"
                      >
                        <div className="profileNameButtonHd">
                          <Avatar
                            className="profilePhotoHD"
                            alt={firstName}
                            src={profileImage}
                          />
                          <div className="user_verified_unverified_hd">
                            {userAccess.userStatus &&
                              userAccess?.userStatus == "FA" && (
                                <img
                                  src={ProfileVerifiedSmall}
                                  alt="Profile Verified"
                                />
                              )}
                            {userAccess.userStatus &&
                              userAccess?.userStatus != "FA" && (
                                <img
                                  src={ProfileUnverifiedSmall}
                                  alt="Profile Unverified"
                                />
                              )}
                          </div>
                        </div>
                        <Typography variant="p" className="profileName">
                          {firstName} {lastName} <ExpandMoreIcon />
                        </Typography>
                      </Button>
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                    >
                      {settings.map((setting) => (
                        <MenuItem
                          key={setting}
                          onClick={() => menuClick(setting)}
                        >
                          <Typography textAlign="center">{setting}</Typography>
                        </MenuItem>
                      ))}
                      {/* <MenuItem>
                                <Link href="">Profile</Link>
                                <Link href="">CV Builder</Link>
                                <Link href="">Portfolio</Link>
                                <Link href="">Logout</Link>
                            </MenuItem> */}
                    </Menu>
                  </>
                )}
                {!localStorage.getItem("userID") && (
                  <Grid className="non_login">
                    <Link
                      href={`${process.env.PUBLIC_URL}/signin`}
                      className="login mob-hide"
                    >
                      Sign in
                    </Link>
                    <Link href={`${process.env.PUBLIC_URL}/register`}>
                      Sign up
                    </Link>
                  </Grid>
                )}
                {/* <Grid className='hd_searchbar_icon'>
                                <SearchIcon onClick={toggleDrawer(true)}/>
                            </Grid> */}
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
        {/* <Grid className='commanErrorMSG_main'>
                <Grid container className='commanErrorMSG'>
                    <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error message which is page level
                    </Alert>
                </Grid>
            </Grid>

            <Stack spacing={2} sx={{ width: '100%' }}>
                <Button variant="outlined" onClick={handleClickTost}>
                    Open success snackbar
                </Button>
                <Snackbar open={openTost} autoHideDuration={6000} onClose={handleCloseTost}>
                    <Alert onClose={handleCloseTost} severity="success" sx={{ width: '100%' }}>
                    This is a success message!
                    </Alert>
                </Snackbar>
            </Stack> */}

        <Root className="hd_searchbar_icon_drawer">
          {/* <CssBaseline /> */}
          {/* <Global
                    styles={{
                    '.MuiDrawer-root > .MuiPaper-root': {
                        height: `calc(50% - ${drawerBleeding}px)`,
                        overflow: 'visible',
                    },
                    }}
                /> */}
          {/* <Box sx={{ textAlign: 'center', pt: 1 }}>
                    <Button onClick={toggleDrawer(true)}>Open</Button>
                </Box> */}
          <SwipeableDrawer
            className="hd_searchbar_icon_drawer_inner"
            container={container}
            anchor="bottom"
            open={openSearchBar}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            swipeAreaWidth={drawerBleeding}
            disableSwipeToOpen={false}
            ModalProps={{ keepMounted: true }}
          >
            {/* <StyledBox
                    sx={{
                        position: 'absolute',
                        top: -drawerBleeding,
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        visibility: 'visible',
                        right: 0,
                        left: 0,
                    }}
                    >
                    <Puller />
                    <Typography sx={{ p: 2, color: 'text.secondary' }}>51 results</Typography>
                    </StyledBox> */}
            <StyledBox
              sx={{
                px: 2,
                pb: 2,
                height: "100%",
                overflow: "auto",
              }}
            >
              {/* <Skeleton variant="rectangular" height="100%" /> */}
              <div className="search_main1">
                <div className="search_main_inner">
                  <Input
                    onKeyDown={(e) => keyPressed(e)}
                    endAdornment={
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    }
                  />
                </div>
              </div>
            </StyledBox>
          </SwipeableDrawer>
        </Root>
      </Grid>
      {isProfilePage == true && profileReducer.ownProfile == true && (
        <ConfirmationPopup isFeedPage={isFeedPage}></ConfirmationPopup>
      )}

      {isProfilePage == false && (
        <ConfirmationPopup isFeedPage={isFeedPage}></ConfirmationPopup>
      )}
    </>
  );
}
Header.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Header;
